import {
    PRESUPUESTADOR_SEARCH_PATENT,
} from '../constants';


export function searchPatent(patente, isCurrent, status) {
    return (dispatch) => {
        dispatch({
            type: PRESUPUESTADOR_SEARCH_PATENT,
            data: { patente, isCurrent, status }
        })
    }
}